import { WidgetCustomers } from "@onefront/workspace-widgets";

const WorkspaceIslandWidgetFactory = (widgetName: string, widgetProps: any) => {
    switch (widgetName.toLowerCase()) {
        case "ws::widget-customers":
            return <WidgetCustomers {...widgetProps} />;
        default:
            return null;
    }
};

export default WorkspaceIslandWidgetFactory;
